import img1 from './images/benef-1.png'
import img2 from './images/benef-2.png'
import img3 from './images/benef-3.png'

export const stepsItems = [
  {
    title: "Include 'price protection' in your listing at NO COST.",
    subtitle: 'Inform your agent and set the payout amount at listing',
    icon: img1.src,
  },
  {
    title: 'Sell your property faster at your asking price.',
    subtitle: 'Attract more buyers and customize payout based on buyer negotiations',
    icon: img2.src,
  },
  {
    title: "Purchase protection post-sale for buyer's benefit.",
    subtitle:
      'Buyer automatically gets big check if prices decline — no claims, no appraisal, no need to sell',
    icon: img3.src,
  },
]
